<template>
    <div>

        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Store Event {{ (store_event.name) ? (" - " + store_event.name) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Store Event - {{store_event.name}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="store_event.code" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="store_event.name" input-classes="form-control" required />
                <base-input alternative="" label="Foot Traffic" placeholder="" v-model="store_event.foot_traffic" input-classes="form-control" required />
                <base-input alternative="date" label="Date"   input-classes="form-control">
                    <a-date-picker v-model="store_event.date" />
                </base-input>
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="store_event.remark" />
                </base-input>

                <base-input label="Store Event Type">
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="storeEventType" disabled>
                        </div>
                        <div class="col-sm-6">
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Store Events"
                                :source="storeEventsEndpoint"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getStoreEventType">
                            </autocomplete>
                        </div>
                    </div>
                </base-input>



            </div>

            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="store_event" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>

            <div v-if="customFormMode == 3">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="store_event.code" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="store_event.name" input-classes="form-control" required />
                        <base-input alternative="" label="Foot Traffic" placeholder="" v-model="store_event.foot_traffic" input-classes="form-control" required />
                        <base-input alternative="date" label="Date"   input-classes="form-control">
                            <a-date-picker v-model="store_event.date" />
                        </base-input>
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="store_event.remark" />
                        </base-input>

                        <base-input label="Store Event Type">
                        <div class="form-group row">
                            <div class="col-sm-6">
                                <input type="text" class="form-control" v-model="storeEventType" disabled>
                            </div>
                            <div class="col-sm-6">
                                <autocomplete
                                    ref="autocomplete"
                                    placeholder="Search Store Events"
                                    :source="storeEventsEndpoint"
                                    input-class="form-control"
                                    results-property="data"
                                    :results-display="formattedDisplay"
                                    :request-headers="authHeaders"
                                    @selected="getStoreEventType">
                                </autocomplete>
                            </div>
                        </div>
                    </base-input>
    
        
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="store_event" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>

            <!-- <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
            </div> -->
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import Autocomplete from 'vuejs-auto-complete'
    import DynamicForm from '../DynamicForm.vue'
    
    var component_x;
    export default {
        components: {
            Autocomplete,
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Store Event?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0) {
                var store_event_data = await HTTPRequest.getRequest(component_x.endPoint + 'store_events/' + component_x.profileId, null)
                if (store_event_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (store_event_data["error"] == undefined) {
                        component_x.store_event = store_event_data
                        component_x.store_eventTypeName = store_event_data["store_event_type_name"]
                    } else {
                        this.errors = store_event_data["error"].split(",")
                    }
                }
            }

            this.dynamicFormKey++;
        },
        data: function () {
            return {
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                store_eventTypeName: '',
                errors: [],

                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                store_event: {
                    name: '',
                    code: '',
                    date: null,
                    foot_traffic: ''
                },
                storeEventType: null,
                formErrors: []
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.store_event
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.store_event = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            storeEventsEndpoint(input) {
                return this.endPoint + '/store_event_types?name=' + input
            },

            getStoreEventType(group) {
                this.storeEventType = group.display
                this.store_event.store_event_type_id = group.value
            },
            formattedDisplay(result) {
                return result.name + ' [' + result.code + ']'
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.store_event.code));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.store_event.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.store_event.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.store_event.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.store_event.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.store_event.name, 0, 50));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var store_eventPayload = {
                    //     store_event: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         store_event_type_id: this.inputStore EventType
                    //     }
                    // }
                    
                    this.store_event.name = this.store_event.name.trim()
                    this.store_event.code = this.store_event.code.trim()
                    this.store_event.status = 'A'
                    var store_eventPayload = { store_event: this.store_event }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'store_events', null, store_eventPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var store_eventPayload = {
                    //     store_event: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         store_event_type_id: this.inputStore EventType
                    //     }
                    // }

                    this.store_event.name = this.store_event.name.trim()
                    this.store_event.code = this.store_event.code.trim()
                    let status = (this.store_event.status == null) ?  "A" : this.store_event.status
                    this.store_event.status = status
                    // this.store_event.status = 'A'
                    var store_eventPayload = { store_event: this.store_event }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'store_events/' + this.profileId, null, store_eventPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>